module.exports = __webpack_public_path__ + "img/levis_0609.f17f1ea8.jpg";